/* TEKES homepage */
(function () {
  var K = document.querySelector('[data-kh]'); if (!K) return;

  // the house: swipe on phones, with a progress line; arrows on desktop only when there are more than three
  var AB = K.querySelector('[data-khab]');
  if (AB) {
    var T = AB.querySelector('[data-track]'), bar = AB.querySelector('[data-bar]'), C = AB.querySelector('[data-ctl]');
    function prog() { var m = T.scrollWidth - T.clientWidth; if (bar) { bar.style.width = Math.min(100, T.clientWidth / T.scrollWidth * 100) + '%'; bar.style.left = (m > 0 ? T.scrollLeft / m * (100 - parseFloat(bar.style.width)) : 0) + '%'; } if (C) C.style.display = innerWidth > 760 && m > 4 ? 'flex' : 'none'; }
    function step(d) { var c = T.firstElementChild; T.scrollBy({ left: d * (c ? c.getBoundingClientRect().width + 8 : 300), behavior: 'smooth' }); }
    AB.querySelector('[data-prev]').onclick = function () { step(-1); };
    AB.querySelector('[data-next]').onclick = function () { step(1); };
    T.addEventListener('scroll', prog, { passive: true }); addEventListener('resize', prog); prog();
  }

  // product rows: one row that scrolls sideways, with arrows to move it
  [].forEach.call(K.querySelectorAll('[data-khrow]'), function (R) {
    var T = R.querySelector('[data-track]'), bar = R.querySelector('[data-bar]'), C = R.querySelector('[data-ctl]');
    function prog() { var m = T.scrollWidth - T.clientWidth, w = Math.min(100, T.clientWidth / T.scrollWidth * 100); bar.style.width = w + '%'; bar.style.left = (m > 0 ? T.scrollLeft / m * (100 - w) : 0) + '%'; C.style.display = m > 4 ? 'flex' : 'none'; }
    function step(d) { var c = T.firstElementChild; T.scrollBy({ left: d * (c ? c.getBoundingClientRect().width + 2 : 300) * (innerWidth > 760 ? 2 : 1), behavior: 'smooth' }); }
    R.querySelector('[data-prev]').onclick = function () { step(-1); };
    R.querySelector('[data-next]').onclick = function () { step(1); };
    T.addEventListener('scroll', prog, { passive: true }); addEventListener('resize', prog); prog();
  });

  // add to bag straight from the homepage, then open the theme's cart
  [].forEach.call(K.querySelectorAll('[data-add]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); if (a.classList.contains('busy')) return;
      var al = a.querySelector('[data-al]'), was = al.textContent;
      a.classList.add('busy');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +a.dataset.add, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          al.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: j }));
          if (window.SLIDECART_OPEN) Promise.resolve(window.SLIDECART_UPDATE && window.SLIDECART_UPDATE()).then(function () { window.SLIDECART_OPEN(); });
          else location.href = '/cart';
        })
        .catch(function (e) { al.textContent = (e && e.description) || 'Try again'; })
        .finally(function () { setTimeout(function () { a.classList.remove('busy'); al.textContent = was; }, 1800); });
    });
  });

  // the big logo: white and large on landing, travels up into the top bar as you scroll and stays there
  // the visible header logo (themes can carry more than one copy, for example inside the menu drawer)
  function seen(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }
  var L = K.querySelector('[data-khlogo]'), A, H, items = [], q = 0;
  function find() {
    var all = [].slice.call(document.querySelectorAll('a.header__logo-image'));
    A = all.filter(seen)[0] || all[0]; if (!A) return;
    H = A.closest('.header') || A.closest('header') || A.parentNode;
    [].forEach.call(A.querySelectorAll('img'), function (i) { i.style.visibility = 'hidden'; });
    items = [].filter.call(H.querySelectorAll('a,button'), function (el) { return seen(el) && el !== A && !A.contains(el); });
  }
  find();
  if (!L || !A) { if (L) L.remove(); return; }
  // the top of the page content (under the announcement bar, if there is one), measured live so it follows editor changes
  var CV = K.querySelector('.kh-cover');
  document.body.classList.add('kh-on');
  // how light a picture is behind a given spot: read from a tiny copy of the picture
  var cache = new Map();
  function lum(img, x, y, hw, hh) {
    var d = cache.get(img);
    if (d === undefined) {
      cache.set(img, null);
      var sm = new Image(); sm.crossOrigin = 'anonymous';
      sm.onload = function () { try { var w = 80, h = Math.max(1, Math.round(80 * sm.naturalHeight / sm.naturalWidth)), c = document.createElement('canvas'); c.width = w; c.height = h; var g = c.getContext('2d'); g.drawImage(sm, 0, 0, w, h); cache.set(img, { w: w, h: h, p: g.getImageData(0, 0, w, h).data }); tick(); } catch (e) {} };
      sm.src = (img.currentSrc || img.src).replace(/([?&])width=[0-9]+/, '$1width=160');
    }
    if (!d) return null;
    var r = img.getBoundingClientRect(), sc = Math.max(r.width / d.w, r.height / d.h), ox = (r.width - d.w * sc) / 2, oy = (r.height - d.h * sc) / 2;
    var x0 = Math.max(0, Math.floor((x - hw - r.left - ox) / sc)), x1 = Math.min(d.w - 1, Math.ceil((x + hw - r.left - ox) / sc));
    var y0 = Math.max(0, Math.floor((y - hh - r.top - oy) / sc)), y1 = Math.min(d.h - 1, Math.ceil((y + hh - r.top - oy) / sc));
    var t = 0, n = 0;
    for (var j = y0; j <= y1; j++) for (var i = x0; i <= x1; i++) { var k = (j * d.w + i) * 4; t += 0.2126 * d.p[k] + 0.7152 * d.p[k + 1] + 0.0722 * d.p[k + 2]; n++; }
    return n ? t / n : null;
  }
  // what sits behind a spot: the homepage blocks say whether they are light, dark, or a picture to measure (innermost first, so a picture inside a white section is measured)
  var zones = [].slice.call(K.querySelectorAll('[data-tone]'));
  function tone(x, y, hw, hh) {
    for (var i = zones.length - 1; i >= 0; i--) {
      var z = zones[i], r = z.getBoundingClientRect();
      if (!r.width || x < r.left || x >= r.right || y < r.top || y >= r.bottom) continue;
      if (z.dataset.tone !== 'img') return z.dataset.tone;
      var im = [].filter.call(z.querySelectorAll('img'), seen)[0]; if (!im) return 'dark';
      var l = lum(im, x, y, hw || 14, hh || 14); return l !== null && l > 150 ? 'light' : 'dark';
    }
    return 'light';
  }
  function paint() { items.forEach(function (el) { var r = el.getBoundingClientRect(); if (!r.width) return; el.style.setProperty('color', tone(r.left + r.width / 2, r.top + r.height / 2) === 'dark' ? '#fff' : '#000', 'important'); }); }
  function logo() {
    q = 0;
    find();
    var vw = innerWidth, vh = innerHeight, mob = vw <= 760;
    // desktop: a third of the width, halfway down the screen; phones: almost full width, at the very top like a magazine masthead, with the menu and icons waiting until you scroll
    var w0 = mob ? vw * 0.88 : Math.min(vw * 0.31, 900), h0 = w0 / 4;
    var x0 = (vw - w0) / 2, HT = CV ? Math.max(0, CV.getBoundingClientRect().top + scrollY) : 0, y0 = mob ? HT + vw * 0.05 : (vh - h0) / 2;
    document.body.classList.toggle('kh-top', mob && scrollY < 40);
    var p = Math.min(1, Math.max(0, scrollY / (vh * 0.6))), e = 1 - Math.pow(1 - p, 3);
    var tr = A.getBoundingClientRect();
    var w = w0 + (tr.width - w0) * e, x = x0 + (tr.left - x0) * e, y = y0 + (tr.top + (tr.height - tr.width / 4) / 2 - y0) * e, s = w / w0;
    L.style.width = w0 + 'px';
    L.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
    L.style.opacity = 1;
    L.classList.toggle('dark', tone(x + w0 * s / 2, y + h0 * s / 2, w0 * s / 2, h0 * s / 3) === 'light');
    paint();
  }
  function tick() { if (!q) q = requestAnimationFrame(logo); }
  addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(tick, 50); }); });
  logo(); setTimeout(logo, 300); addEventListener('load', logo);
})();